import type { AccountSummary } from '@fruitful/types';
import {
    BodyLargeEmphasized,
    BodyMediumEmphasized,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CloseButton,
    FootnoteEmphasized,
    HolisticAccountLogo,
    isWeb,
    UnlinkIcon,
    View,
    XStack,
    YStack,
} from 'smoothie';

interface LinkedAccountDetailsProps {
    linkedAccount: AccountSummary;
    onEdit: () => void;
    onUnlink: () => void;
    onDismiss: () => void;
}

const LinkedAccountDetails = ({
    linkedAccount,
    onEdit,
    onUnlink,
    onDismiss,
}: LinkedAccountDetailsProps) => {
    const { accountNumberMasked, name, institutionName, logo } = linkedAccount;

    return (
        <YStack
            paddingTop={20}
            paddingHorizontal={20}
            gap={20}
            alignItems="center"
            justifyContent="center"
            maxHeight={isWeb ? '60vh' : 350}
            paddingBottom={isWeb ? 16 : undefined}
        >
            <XStack
                width="100%"
                alignItems="center"
                justifyContent="space-between"
            >
                <View width={30} height={30} />
                <BodyMediumEmphasized>Linked account</BodyMediumEmphasized>
                <CloseButton backgroundColor="$gray200" onPress={onDismiss} />
            </XStack>
            <HolisticAccountLogo
                institutionName={institutionName}
                logo={logo}
                size="lg"
            />

            <YStack alignItems="center" justifyContent="center">
                <FootnoteEmphasized color="$gray1200">
                    {institutionName}
                </FootnoteEmphasized>
                <BodyLargeEmphasized color="$gray1200">
                    {name}
                </BodyLargeEmphasized>
                <BodyMediumRegular color="$gray800">
                    *{accountNumberMasked}
                </BodyMediumRegular>
            </YStack>

            <Button
                variant={ButtonVariant.SECONDARY}
                size={ButtonSize.LARGE}
                tone="positive"
                text="Change account"
                onPress={onEdit}
            />

            <Button
                variant={ButtonVariant.TERTIARY}
                tone="danger"
                size={ButtonSize.SMALL}
                text="Unlink"
                icon={UnlinkIcon}
                onPress={onUnlink}
            />
        </YStack>
    );
};

export default LinkedAccountDetails;
